var CommonLogin = (function () {

    let $findEmailInput
    let UserTracker;

    return {
        goLogin: goLogin,
        goAutoLogin: goAutoLogin,
        EncodeAES: encodeAES,
        setAutoCheck: setAutoCheck,
        clickAutoCheck: clickAutoCheck,
        keydownLoginInput: keydownLoginInput,
        keyupPasswordInput: keyupPasswordInput,
        addClickEventOnSignIn: addClickEventOnSignIn,
        addKeyEventOnSignIn: addKeyEventOnSignIn,
        checkSnsLoginAvailable: checkSnsLoginAvailable,
        checkUserIdBefore: checkUserIdBefore,
        setUserIdIn$Input :  setUserIdIn$Input,
        splitAutoLoginKey: splitAutoLoginKey,
        moveMainPage: moveMainPage,
        isErrorBeforeNormalLogin: isErrorBeforeNormalLogin,
        isErrorAfterLogin: isErrorAfterLogin,

        clickBottomSection: clickBottomSection,
        changeFindPwdView: changeFindPwdView,
        createAutoLoginKey: createAutoLoginKey,
        checksExternalLogin: checksExternalLogin,

        getOTPType: getOTPType,
    }

    function checksExternalLogin(callback) {
        const isElectron = ElectronApi.Comm.isElectron();
        if (EnterCommonConfig.isExternalLogin() && !window.isInviteSns && isElectron) {
            Often.toast('error', '외부인으로 시작하시려면 초대장이 필요합니다. (초대받은 URL 주소를 다시 확인해주세요.)');
            return;
        }
        callback();
    }

    function checkSnsLoginAvailable() {
        try {
            var isAllSnsBlock = (!googleApiAvailable || !googlePlatFormAvailable) && !kakaoApiAvailable && !appleApiAvailable;
            $(_IsMini ? "#miniSocialLoginButton" : "#loginLayer .guest-or").css('display', getSnsBtnDisplay(!isAllSnsBlock));
            $("#googleLoginButton").css('display', e => {
                getSnsBtnDisplay(googleApiAvailable && googlePlatFormAvailable)
            });
            $("#kakaoLoginButton").css('display', e => {
                getSnsBtnDisplay(kakaoApiAvailable)
            });
            $("#appleLoginButton").css('display', e => {
                getSnsBtnDisplay(appleApiAvailable)
            });

            function getSnsBtnDisplay(apiConSuccessVal) {
                return apiConSuccessVal ? 'flex' : 'none';
            }
        } catch (e) {
        }
    }

    function checkUserIdBefore() {
        if (ServerChecker.isBnk) {
            return;
        }
        var userIdByCookie = Often.getCookie("MINI_USER_ID");
        if (ServerChecker.isKyowon) userIdByCookie = Often.getCookie("MINI_CUR_USER_ID");
        if (ServerChecker.isSeco) {
            userIdByCookie = userIdByCookie === "" ? "" : userIdByCookie.split("^")[1];
            if (Often.getCookie('SECO_COMPANY_NAME') !== '') $(".company-select-list #companyName").val(Often.getCookie('SECO_COMPANY_NAME'));
        }
        if (userIdByCookie !== "") {
            setUserIdIn$Input(userIdByCookie)
        }
        if (ServerChecker.isKsfc) $('.otp-select-list #otpName').val('M-OTP');
    }
    function setUserIdIn$Input(userId ="") {
        if(Mutil.empty(userId)) {
            return;
        }

        $("#userId").val(userId);
        $("#password").focus();
    }
    function addClickEventOnSignIn() {
        //로그인
        addKeyEventOnSignIn();
        if (Often.isMobile() || Often.isTablet()) {
            $("#pwdViewBtn").off("mousedown mouseup").on("mousedown", CommonJoin.mousedownViewToggleButton);
        } else {
            $("#pwdViewBtn").off("mousedown mouseup").on({
                mouseup: CommonJoin.mouseupViewButton,
                mousedown: CommonJoin.mousedownViewButton,
            });
        }

        UserTracker = UserTracker || requireModule('userTracker', {on: ['signin', 'miniSignIn', 'corpsignin']})();
        $("#normalLoginButton").off("click").on("click", e => {
            UserTracker?.SignInTracker()?.track(_IsMini ? "mini-login-click" : "normal-login-click");
            NormalLogin.clickNormalLoginButton();
        });
        $("#signupBnt2").off("click").on("click", () => {
            const projectInviteKey = Often.null2Void(window.CONNECT_INVITE_KEY);
            Often.submitForm("invite_form", "/signup.act", "_self", {INVT_KEY: projectInviteKey});
        });
        $(".backToSignin").off("click").on("click", () => {
           window.history.back()
        })

	    $(".otp-select-list").off("click").on("click", getOTPType);
	    $(".auth-section").off("click").on("click", (e) => {
		    if ($(e.target).closest('.otp-select-list').length > 0 && !$('.dropdown-menu').hasClass('on')) $('.dropdown-menu').addClass('on');
		    else $('.dropdown-menu').removeClass('on');
	    })

        $(".company-select-list").off("click").on("click", getCompanyCode);
        $(".auth-section, .mini-body").off("click").on("click", (e) => {
            $('.dropdown-menu').removeClass('on');
        })

        if (_IS_EXTERNAL_LIB) {
            googleApiAvailable && $("#googleLoginButton").off("click").on("click", () => {
                UserTracker?.SignInTracker()?.track(_IsMini ? "google-mini-login" : "google-login");
                checksExternalLogin(GoogleLogin.clickGoogleLoginButton)
            });
            kakaoApiAvailable && $("#kakaoLoginButton").off("click").on("click", () => {
                UserTracker?.SignInTracker()?.track(_IsMini ? "kakao-mini-login" : "kakao-login");
                checksExternalLogin(KakaoLogin.clickKakaoLoginButton)
            });
            appleApiAvailable && $("#appleLoginButton").off("click").on("click", () => {
                UserTracker?.SignInTracker()?.track(_IsMini ? "apple-mini-login" : "apple-login");
                checksExternalLogin(AppleLogin.clickAppleLoginButton)
            });
        }

        if ($("#bmwLoginButton").length > 0) {
            $("#bmwLoginButton").off("click").on("click", async () => {
                const {LOGIN_URL} = await Ajax.executeApi("BMW_SSO_LOGIN", {});
                location.href = LOGIN_URL;
            })
        }

        $("#autoCheck").off("click").on("click", clickAutoCheck);
        $("#autoCheckLabel").off("click").on("click", clickAutoCheck);
        $("#bottomSection").off("click").on("click", clickBottomSection);

        //비밀번호재설정
        $("#findEmailInput").off("keydown").on("keydown", keyDownFindEmailInput);
        $("#findSubmit").off('click').on('click', sendPwdChangeEmail);
        $("#findBottomSection").off('click').on('click', clickFindBottomSection);

        // 미래에셋 통합 로그인 버튼
        onEventIntegratedAuthLogin();

        if (Func.ENTER.AZURE_LOGIN) {
            const AzureOauth = requireModule("AzureOauth", {on: ['entsignin']});
            AzureOauth()?.handleAzureLoginButtonClick();
        }
    }

    //로그인 키보드 이벤트 설정
    function addKeyEventOnSignIn() {
        $("#userId").off("keydown").on("keydown", keydownLoginInput);
        $("#password").off("keydown").on("keydown", keydownLoginInput);
        $("#password").off("keyup").on("keyup", keyupPasswordInput);
    }

    function clickBottomSection(e) {
        var $eTarget = $(e.target);
        var $passwordFind = $eTarget.closest(".js-password-find")
        if ($passwordFind.length > 0) {
            goFindPwdView();
        }
    }

    function goFindPwdView() {
        var $passwordInput = $("#password");
        UserTracker = UserTracker || requireModule('userTracker', {on: ['signin', 'miniSignIn', 'corpsignin']})();
        if ($passwordInput.hasClass("bizplay")) {
            UserTracker?.SignInTracker()?.track("pw-find", "bizplay");
            Often.submitForm("bizSetPwd", "https://www.bizplay.co.kr/comm_0023_01.act", "_self", {});
            return;
        }

        if (Often.isAct('corpsignin')) {
            UserTracker?.SignInTracker()?.track("corp-pw-find");
            OpenUtil.openWindow('/corpsignin.act?c=findPwd', 'findPwd');
            return;
        }

        if (window.ElectronProcessApi) {
            UserTracker?.SignInTracker()?.track("mini-pw-find");
            const baseUrl = window.location.href.split("/").slice(0, 3).join("/")
            OpenUtil.openWindow(`${baseUrl}/signin.act?findPassword=Y`, '');
            return;
        }
        UserTracker?.SignInTracker()?.track("pw-find");
        changeFindPwdView();
    }

    function changeFindPwdView() {
        toggleLayer(true);
        $findEmailInput = $("#findEmailInput");
        $findEmailInput.focus();
    }

    function clickFindBottomSection(e) {
        var $eTarget = $(e.target);

        var $signupText = $eTarget.findUp(".js-signup-text");
        if ($signupText.length > 0) {
            location.href = "/signup.act";
            return;
        }

        var $signinText = $eTarget.findUp(".js-signin-text");
        if ($signinText.length > 0) {
            toggleLayer(false);
        }
    }

    function toggleLayer(isPasswordFind) {
        var $findPassword = $("#findPassword");
        $findEmailInput = $("#findEmailInput")
        $("#loginLayer").css("display", isPasswordFind ? "none" : "block");
        $findPassword.css("display", isPasswordFind ? "block" : "none");
        $findEmailInput.val($("#userId").val());
        $findEmailInput.removeClass('input-error')
        $findPassword.find(".js-password-alert").text("");

        //비밀번호재설정
        if (isPasswordFind) {
            $findEmailInput.off("keydown").on("keydown", keyDownFindEmailInput);
            $("#findSubmit").off('click').on('click', sendPwdChangeEmail);
            $("#findBottomSection").off('click').on('click', clickFindBottomSection);
        }
    }

    function keyDownFindEmailInput(event) {
        if (event.keyCode === 13) {
            UserTracker = UserTracker || requireModule('userTracker', {on: ['signin', 'miniSignIn', 'corpsignin']})();
            UserTracker?.SignInTracker()?.track("pw-find-email-enter")
            sendPwdChangeEmail();
        }
    }

    function keydownLoginInput(e) {
        var $eTarget = $(e.target);
        var $errorText = _IsMini ? $("#errorText") : $eTarget.parent().find(".error-text");
        var subDom = window.SUB_DOM;
        var isSSO = window.location.href.includes("ssoSignin");
        let isPassClearError = false;
        let isPasswordInput = $eTarget.findUp('#password').length > 0;
        const isEnterprise = _ENTER_YN === "Y";
        const notSubdom = "" === Often.null2Void(subDom);
        const isInputEnter = 'Enter' === e.key;

        if (isEnterprise && KeyCheck.isCapsLockOn(e) && isPasswordInput) {
            $errorText.text(i18next.t(login.capsLockOn));
            isPassClearError = true;
        }

        if (Often.null2Void($errorText.text()) !== "" && !isPassClearError) {
            clearError($eTarget);
            $errorText.text("");
            return;
        }

        if ((isEnterprise || notSubdom) && isInputEnter && !isErrorBeforeNormalLogin()) {
            UserTracker = UserTracker || requireModule('userTracker', {on: ['signin', 'miniSignIn', 'corpsignin']})();
            UserTracker?.SignInTracker()?.track("normal-login-enter");
            NormalLogin.clickNormalLoginButton();
            $(':focus').blur();
        }
    }

    function keyupPasswordInput(e) {
        const $eTarget = $(e.target);
        const isExistPassword = "" !== $eTarget.val();
        let $errorText = _IsMini ? $("#errorText") : $eTarget.parent().find(".error-text");

        Validation.checkPasswordAllowedCharacters($eTarget.val(), function () {
            Often.toast("error", i18next.t(main.alert.eightDigitPasswordLimit));
            e.target.value = e.target.value.replace(/([^!-~])+/ig, "")
        });

        $("#pwdViewBtn").css("display", isExistPassword ? "block" : "none");
        if(_IsMini) KeyCheck.isCapsLockOn(e) ? $errorText.addClass('active') : $errorText.removeClass('active');
        $errorText.text(KeyCheck.isCapsLockOn(e) ? i18next.t(login.capsLockOn) : "");
    }

    function clickAutoCheck(e) {
        let isChecked;
        if (_IsMini) {
            isChecked = MiniLogin.clickMiniAutoCheck(e)
        } else {
            const $t = $(e.currentTarget);
            $t.toggleClass('auto-login-active');
            isChecked = $t.hasClass('auto-login-active')
        }

        const autoLoginCheckedYN = isChecked ? "Y" : "N";
        LocalUtil.setLocal("ONLY_AUTO_LOGIN_YN", autoLoginCheckedYN);
        Often.setCookie("autoLoginCheckYN", autoLoginCheckedYN, 30 * 12);
        UserTracker = UserTracker || requireModule('userTracker', {on: ['signin', 'miniSignIn', 'corpsignin']})();
        UserTracker?.SignInTracker()?.track("auto-login-check", autoLoginCheckedYN)
    }

    function setAutoCheck() {
        const isElectron = ElectronApi.Comm.isElectron();
        const $checkIcon = $("#autoCheck");

        let autoLoginCheckYN = LocalUtil.getLocal("ONLY_AUTO_LOGIN_YN");
        if (autoLoginCheckYN === null) {
            if(_IsMini){
                autoLoginCheckYN = "Y"
            }
            else {
                autoLoginCheckYN = "N";
            }
            Often.setCookie("autoLoginCheckYN", autoLoginCheckYN)
            LocalUtil.setLocal("ONLY_AUTO_LOGIN_YN", autoLoginCheckYN);
        }

        if (HecConfig.isHec()) {
            $checkIcon.hide();
            autoLoginCheckYN = 'N';
        }

        if (isElectron && _IsMini) {
            return MiniLogin.setMiniAutoCheck(autoLoginCheckYN);
        }

        $checkIcon.attr("class", "auto-login-label" + (autoLoginCheckYN === "Y" ? " auto-login-active" : ""));
        LocalUtil.setLocal("ONLY_AUTO_LOGIN_YN", autoLoginCheckYN);
    }

    function goLogin(passJson, callback) {
        var isNormal = passJson.ID_GB === SignCode.TYPE.NORMAL;
        var isSeco = passJson.ID_GB === SignCode.TYPE.SECO;
        var isGoogle = passJson.ID_GB === SignCode.TYPE.GOOGLE;
        var isSocial =  [SignCode.TYPE.GOOGLE, SignCode.TYPE.APPLE, SignCode.TYPE.KAKAO, SignCode.TYPE.AZURE]
            .some(code => code === passJson.ID_GB) ;

        if ((isNormal || isSeco) && isErrorBeforeNormalLogin()) return;
        Often.setCookie("googleLoginYn", isGoogle ? "Y" : "N");
        var deviceJson = Often.getDeviceJson(_CLIENT_IP);
        Often.setCookie("FLOW_DUID", deviceJson.DUID);
        var companyCode = $.trim($("#companyCode").val());
        passJson.USER_ID = passJson.USER_ID.toString();

        Ajax.executeApi(RestApi.GET.FLOW_CUR_TIME_R001, {USER_ID: passJson.USER_ID}, async function (dat) {
            Often.setCookie("DATE_TIME", dat['CUR_DTTM']);
            let loginData = $.extend({}, deviceJson, passJson, {
                packetOption: Ajax.OPTION.PREVENT_EXECUTE,
                SUB_DOM: _ENTER_YN === "Y" ? "" : Often.null2Void(SUB_DOM),
                CP_CODE: companyCode,
                AUTH_TYPE: ServerChecker.isKsfc ? passJson.OTP_TYPE : '',
            });

            if (!Often.isEmpty(loginData?.CP_CODE)) loginData.SUB_DOM = loginData.CP_CODE;
            const crypto = window.FlowCrypto && FlowCrypto();
            const rsaPublicKey = dat['KEY'];
            if (crypto && rsaPublicKey) {
                loginData.ENCRYPT_YN = 'RSA';
                loginData.USER_ID = crypto.encrypt(rsaPublicKey, loginData.USER_ID);
                loginData.PWD = Mutil.exist(passJson["PWD"]) ? crypto.encrypt(rsaPublicKey, passJson["PWD"]) : "";
            } else {
                loginData.PWD = encodeAES(passJson["PWD"], dat['CUR_DTTM']);
            }

            //[NOTE] RSA TEST 검색하면 쿠키로 디버깅 가능한 로직 살릴 수 있음 20230811 by @민호
            const loginResponse = await Ajax.executeApi(RestApi.GET.COLABO2_LOGIN_R003, loginData);

            const {
                TEAMS_CONNECT_YN = "N",
                FIRST_LOGIN_YN,
                AUTH_YN,
                AUTH_TYPE,
                USER_ID,
                EML,
                CLPH_NO,
                AUTH_TIME_MM,
                AUTH_NO,
                JWT,
                OTP_TR_ID,
                ROLE_INFO,
	            RESULT_ADDR,
                ACCESS_TOKEN,
                EXTERNAL_TOKEN,
                RSLT_CD  = "",
                ERR_MSG = ""
            } = loginResponse;

            if("5004" === RSLT_CD){
                return Often.toast("info", ERR_MSG);
            }

            if(JWT) {
                Often.setDomainCookie("ssotoken2", JWT, '.ksfc.co.kr', 1);
                Often.setDomainCookie("ROLE_INFO", getRoleInfo(ROLE_INFO), '.ksfc.co.kr', 1);
            }

            if(ACCESS_TOKEN) {
                Often.setDomainCookie("ssotoken", ACCESS_TOKEN, '.ksfc.co.kr', 1, "", false);
            }
            if (EXTERNAL_TOKEN) {
                Often.setDomainCookie("eptoken", EXTERNAL_TOKEN, '.ksfc.co.kr', 1);
            }

            if (TEAMS_CONNECT_YN === "Y") LocalUtil.setLocal("INIT_MS_TEAMS", "Y");

            const firstLoginYn = Often.null2Void(FIRST_LOGIN_YN, "N");
            const desktopGuideYn = Often.null2Void(passJson.DESKTOP_GUIDE_YN);
            const isSubDomain = window?.SUB_DOM !== ""
            if(isSubDomain) Mutil.closeLoadingPop();

            if (isErrorAfterLogin(loginResponse, firstLoginYn === "Y", isSocial)) return;

            if (window.completeLoginCallback?.()) {
                window.completeLoginCallback?.()
                return;
            }

            if(Often.isGlobal() && typeof window.growsumo !== "undefined" && !!window.growsumo?.data.partner_key) {
                growsumo.data.customer_key = passJson.USER_ID;
                growsumo.data.email = passJson.USER_ID;
                growsumo.data.name = passJson.USER_ID;
                growsumo.createSignup();
            }

            const thirdParty = isThirdParty();

            if (thirdParty.isTeams) {
                location.href = location.origin + "/email_extension_auth.act?client_id=" + new URL(location.href).searchParams.get("client_id") + "&redirect_uri=" + new URL(location.href).searchParams.get("redirect_uri") + "&state=" + new URL(location.href).searchParams.get("state") + "&code='" + loginResponse.USER_ID + "'" + "&teams_app=true&access_token=" + new URL(location.href).searchParams.get("access_token") + "&refresh_token=" + new URL(location.href).searchParams.get("refresh_token");
                return;
            } else if(thirdParty.isOutlookOAuth){
                location.href = location.origin + "/email_extension_auth.act?client_id=" + new URL(location.href).searchParams.get("client_id") + "&redirect_uri=" + new URL(location.href).searchParams.get("redirect_uri") + "&state=" + new URL(location.href).searchParams.get("state") + "&code=" + loginResponse.USER_ID + "&outlook_addin=true&access_token=" + new URL(location.href).searchParams.get("access_token") + "&refresh_token=" + new URL(location.href).searchParams.get("refresh_token");
                return;
            } else if (thirdParty.isGmailOAuth){
                location.href = location.origin + "/email_extension_auth.act?client_id=" + new URL(location.href).searchParams.get("client_id") + "&redirect_uri=" + new URL(location.href).searchParams.get("redirect_uri") + "&state=" + new URL(location.href).searchParams.get("state") + "&code=" + loginResponse.USER_ID;
                return;
            }

            let authType = Often.null2Void(AUTH_TYPE, "");//E:메일,H:핸드폰,EH:모두존재

            const isRequireTwoFactor = Often.null2Void(AUTH_YN, "N") === "N" && Mutil.exist(authType);

            if(ServerChecker.isKsfc){
                if (isRequireTwoFactor) {
                    if(OTP_TR_ID) Often.setCookie("OTP_TR_ID", OTP_TR_ID,1);
                    const TwoFactorPop = requireModule('TwoFactorPop', {on: ['signin', 'corpsignin', 'miniSignIn']});
                    TwoFactorPop()?.render({authType, eml: EML, clphNo: CLPH_NO, timeLimit: AUTH_TIME_MM});
                    return;
                }
            } else if (ServerChecker.isEnter) {
                if (isRequireTwoFactor) {
                    const authId = EmailAuth.getAuthId({AUTH_TYPE, EML, CLPH_NO});
                    if (authId === "") return;
                    EmailAuth.openAuthView(USER_ID, authId, AUTH_TYPE, false, successTwoFactor);
                    EmailAuth.setCounter({AUTH_TIME_MM, AUTH_NO});
                    return;
                }
                if (EnterCommonConfig.isExternalLogin) {
                    Often.setCookie("IS_INVITE_SNS", "Y", 30 * 12);
                }
                if (ServerChecker.isKyowon) {
                    Often.setCookie("MINI_CUR_USER_ID", passJson.USER_ID, 30 * 12);
                }
                if(ServerChecker.isSeco) {
                    Often.setCookie("FLOW_RND_KEY", loginResponse.RNDKEY, 30 * 12);
                }
            }

            if (isRequireTwoFactor) {
                if(Mutil.isAct("/newSignup.act") && typeof callback === "function") {
                    callback(isRequireTwoFactor, {firstLoginYn, desktopGuideYn});
                    return ;
                }
                if(OTP_TR_ID) Often.setCookie("OTP_TR_ID", OTP_TR_ID,1);
                const TwoFactorPop = requireModule('TwoFactorPop', {on: ['signin', 'corpsignin', 'corpsignup', 'miniSignIn']});
                TwoFactorPop()?.render({
                    authType,
                    eml: EML,
                    clphNo: CLPH_NO,
                    timeLimit: AUTH_TIME_MM,
                    userId : passJson.USER_ID ,
                    isPass :  Often.null2Void(passJson.PASS_CHECK_2FA_YN, "N") === "Y",
                    successCallback : () => {
                        goLogin(passJson);
                    }});
                return;
            }


            Often.setCookie("hubspotTrackJson", "");
            Often.setCookie("MINI_USER_ID", USER_ID, 30 * 12);

            await createAutoLoginKey(USER_ID);

            Loading.closeLoading();
            if (typeof callback === "function") {
                if(Mutil.isAct("/newSignup.act")) {
                    callback(isRequireTwoFactor, {firstLoginYn, desktopGuideYn});
                    return ;
                }
                return callback();
            }
            if ("" !== Often.null2Void(window.surveySrno)) return location.reload();
            if (!!window.isAdminUserPage) {
                Often.setCookie("BASE_PAGE", "main.act");
                Often.submitForm("flow-user", `/${Often.getAdminPage()}`, "_self", {
                    MENU: "flow-user",
                });
                return;
            }

            moveMainPage({firstLoginYn, desktopGuideYn, RESULT_ADDR: RESULT_ADDR});
        });
    }

    function getRoleInfo(str = "") {
        try {
            const decoded = decodeURIComponent(str);

            const result = {
                ROLE_NAME: [],
                ROLE_ID: []
            };

            const segments = decoded.split('*');

            segments.forEach(segment => {
                // 'SNAME-' 패턴에 맞는 경우
                if (segment.startsWith('SNAME-')) {
                    result.ROLE_NAME.push(segment.substring('SNAME-'.length));
                }
                // 'SID-' 패턴에 맞는 경우
                else if (segment.startsWith('SID-')) {
                    result.ROLE_ID.push(segment.substring('SID-'.length));
                }
                // 'ID-' 패턴에 맞는 경우
                else if (segment.startsWith('ID-')) {
                    result.ROLE_ID.push(segment.substring('ID-'.length));
                }
            });

            return result.ROLE_ID.join("_");
        } catch (e) {
            console.error('getRoleInfo', e);
            return "";
        }
    }

    function goAutoLogin() {
        const isElectron = ElectronApi.Comm.isElectron();
        const autoLoginKey = Often.getCookie((isElectron ? "mini" : "") + "flowLogin");
        const isAutoLogin = ("" !== autoLoginKey) && (LocalUtil.getLocal("N_ONLY_AUTO_LOGIN_YN") ?? Often.getCookie("autoLoginCheckYN")) !== 'N';
        const autoLoginKeyJson = splitAutoLoginKey(autoLoginKey);

        if ((ServerChecker.isSeco && SecoConfig.is("LIMIT_AUTO_LOGIN")) || !isAutoLogin || Object.keys(autoLoginKeyJson).length === 0) return;
        var deviceJson = Often.getDeviceJson(_CLIENT_IP);
        Often.setCookie("FLOW_DUID", deviceJson.DUID);
        Ajax.executeApi(RestApi.GET.COLABO2_AUTO_LOGIN_R002, autoLoginKeyJson, function (dat) {
            var isIncorrectRandkey = (dat.RESULT_CODE === "0001");
            if (isIncorrectRandkey) {
                Often.setCookie((isElectron ? "mini" : "") + "flowLogin", "");
                console.error(
                    "다른 기기에 자동 로그인을 설정했기 때문에, 해당 기기에서는 자동 로그인이 비활성화되었습니다.",
                    "Because you set up automatic login on another device, automatic login has been disabled on that device."
                );
                return {}; // @우성호: https://flow.team/l/PYxt4
            }
            if(isThirdParty().anyMatch) return;
            moveMainPage({RESULT_ADDR : dat.RESULT_ADDR});
        });
    }

    function isErrorBeforeNormalLogin() {
        var checkJson = Validation.checkInput($("#loginForm input:visible"));
        var errorObj = checkJson.errorObj;
        $(".error-text").text("");
        if (Object.keys(checkJson).length === 0) return false;
        if (_IsMini) {
            var errorText = $("#errorText");
            errorText.addClass('active');
            errorText.attr('data-error-code', checkJson.errorCode).text(checkJson.errorMessage);
            createError(errorObj);
            return true;
        }
        errorObj.parent().find(".error-text").text(checkJson.errorMessage);
        createError(errorObj);
        return true;
    }

    function isErrorAfterLogin(dat, isFirstLogin, isSocial = false) {
        var $errorInput;
        var errorCode = Often.null2Void(dat['ERR_CD'], "0");
        if (errorCode === SignCode.ERROR.NO_PROBLEM) return false;

        const isOpenJoinCancelWindow = !!window.isJoinCancel && !Mutil.empty(dat['USER_ID']) && errorCode === SignCode.ERROR.WAIT_JOIN;
        if (isOpenJoinCancelWindow) {
            location.href = `/joinwait.act?userId=${dat['USER_ID']}`;
            return true;
        }

        if (subDomainError(errorCode, isFirstLogin)) return true;
        if (ServerChecker.isKyowon && errorCode == "1006") {
            let uid = dat.USER_ID;
            if (!uid) return true;
            let returnUrl = 'https://kportal.kyowon.co.kr/kyowonlogin.aspx?type=KWorkschangepw&uid=' + uid;
            if (ElectronApi.Comm.isElectron) ElectronApi.Window.openExternalLink({url: returnUrl});
            else window.open(returnUrl);
            return true;
        }
        if(ServerChecker.isKsfc && errorCode !== "0000") {
            PopupDraw.drawConfirmOnly({
                contents: {
                    main: dat['ERR_MSG']
                },
                callback: {
                    submit: () => {
                        if (errorCode == "-2443" || errorCode == "-2514") {
                            let returnUrl = dat.CONNECT_URL;
                            window.open(returnUrl);
                        }
                        PopupDraw.closePopup();
                    }
                }
            });
            return true;
        }

        if ((errorCode === SignCode.ERROR.NOT_EXISTS_ID || errorCode === SignCode.ERROR.WAIT_JOIN) && isSocial) {
            Often.toast("error", Often.null2Void(dat['ERR_MSG']));
            return true;
        }

        var isErrorId = errorCode === SignCode.ERROR.NOT_EXISTS_ID || errorCode === SignCode.ERROR.ID_ERROR;
        $errorInput = (isErrorId ? $("#userId") : $("#password"));
        createError($errorInput);

        var $errorText = _IsMini ? $("#errorText") : $errorInput.parent().find(".error-text");
        $errorText.addClass('active');

        let errorMsg = _IsMini ? Often.null2Void(dat['ERR_MSG']).split('.')[0] : Often.null2Void(dat['ERR_MSG']);

        if (ServerChecker.isHiib && errorCode === SignCode.ERROR.ACCOUNT_LOCKED) {
            $errorText.text('비밀번호가 7회 이상 틀리셨습니다. 관리자에게 문의하시기 바랍니다.');
            return true;
        }

        if (errorCode === SignCode.ERROR.TWO_FACTOR_FOR_LOCKED) {
            $errorText.text(Often.null2Void(dat['ERR_MSG']));
            lockedAccountPop(dat);
            return true;
        }

        if (dat?.COMMON_HEAD?.CODE === SignCode.ERROR.NOT_ALLOWED_IP) {
            const errorMsg = i18next.t(login.security.inaccessibleIp);
            Often.toast("error", errorMsg);
            $errorText.text(errorMsg);
            return true;
        }

        if (errorCode === SignCode.ERROR.BIZPLAY_PASSWORD_ERROR) {
            $errorInput.addClass("bizplay");
        } else {
            $errorInput.removeClass("bizplay");
        }

        // 1006 -> 비밀번호 변경 코드 // RESET_PWD_YN -> 비밀번호 초기화 여부 'Y'인 경우 초기화 진행
        if (ServerChecker.isEnter && errorCode === "1006" && Often.null2Void(dat['RESET_PWD_YN'], "Y") === "Y") { // 신세계 비밀번호 초기화 요청
            $errorText.text(Often.null2Void(errorMsg, $errorInput.attr("data-login-err-msg")))
                .attr('data-error-code', errorCode);

            pwdInitPopDefaultSet(dat); // 비밀번호 변경 팝업 기본 셋팅
            return true;
        }

        if (Number(errorCode) > 0) {
            $errorText.text(Often.null2Void(errorMsg, $errorInput.attr("data-login-err-msg")))
                .attr('data-error-code', errorCode);
            return true;
        }

        $errorText.text($errorInput.attr("data-login-err-msg")).attr('data-error-code', errorCode);
        return true;
    }

    function createError(targetObj) {
        if (_IsMini) return MiniLogin.createMiniError(targetObj);
        targetObj.addClass("input-error").focus();
    }

    function clearError($eTarget) {
        if (_IsMini) return MiniLogin.clearMiniError($eTarget);
        $eTarget.removeClass("input-error");
    }

    function subDomainError(errorCode, isFirstLogin) {
        if (SUB_DOM === "") return false;
        if (errorCode === SignCode.ERROR.WAIT_JOIN) {
            if (isFirstLogin && !Often.isMobile()) DesktopGuide.initDesktopGuide(showWaitJoinLayer);
            else showWaitJoinLayer();
            return true;
        }

        if (errorCode === SignCode.ERROR.REJECT_JOIN || // 회사 가입 거절 시
            errorCode === SignCode.ERROR.NOT_EXISTS_DOMAIN) {  // 회사 도메인아 다른 경우(회사가 다르거나 , 게스트 계정)
            var $errorInput = $("#password");
            createError($errorInput);
            var $errorText = $errorInput.parent().find(".error-text");
            $errorText.text(i18next.t(main.alert.invalidCompany));
            return true;
        }

        function showWaitJoinLayer() {
            if (Often.isAct("corpsignup") || Often.isAct("corpsignin")) {
                $(".js-link-home").css("display", "none");
                $("#waitJoinLayer").css("display", "block");
                return;
            }
            CheckJoinPopup.moveWaitLayer();
        }
    }

    function moveMainPage({firstLoginYn = "N", desktopGuideYn = "N", snsYn = "N", RESULT_ADDR = "/main.act"} = {}) {
        const getPageUrl = () =>{
            if(_IsMini) {
                return "/miniMain.act"
            }

            if(RESULT_ADDR === '/portal.act'){
                return RESULT_ADDR;
            }

            if(Mutil.exist(window._POST_LINK)) {
                return `${POST_LINK_PREFIX}${window._POST_LINK}`;
            }

            return "/main.act";
        }

        Often.submitForm("invite_form", getPageUrl(), "_self", {
            INVT_KEY: CONNECT_INVITE_KEY,
            T_COLABO_SRNO: CONNECT_PROJECT_SRNO,
            T_COLABO_COMMT_SRNO: CONNECT_POST_SRNO,
            T_COLABO_REMARK_SRNO: CONNECT_REMARK_SRNO,
            SUB_DOM: SUB_DOM,
            DESKTOP_GUIDE_YN: desktopGuideYn,
            FIRST_LOGIN_YN: firstLoginYn,
            SNS_YN: snsYn,
        })

        if (Mutil.exist(window?._CHAT_TOKEN)) {
            const Launcher = requireModule('Launcher', {on: ['signin', 'miniSignIn']})();
            Launcher.openMessenger(window?.roomSrnoByToken);
        }
    }

    async function createAutoLoginKey(userId) {
        var isAutoCheck = "Y" === LocalUtil.getAutoLogin();
        var isElectron = ElectronApi.Comm.isElectron();

        const isAutoLoginBlock = Often.null2Void(Often.getCookie('isAutoLoginBlock'), "N") === "N"
        if (isAutoLoginBlock && !isAutoCheck) {
            Often.setCookie((isElectron ? "mini" : "") + "flowLogin", "");
            Often.setCookie("isAutoLoginBlock", "Y");
            return;
        }

        await Ajax.executeApi(RestApi.GET.COLABO2_AUTO_LOGIN_R001, {
            USER_ID: userId,
            OBJ_CNTS_NM: (isElectron ? "desktop" : "")
        }, function (dat) {
            Often.setCookie((isElectron ? "mini" : "") + "flowLogin", userId + "|" + dat.RAND_KEY, 30 * 12);
        })
    }

    function encodeAES(plainText, currentDate) {
        var key = "aes256-global-flow";
        GibberishAES.size(256);
        return GibberishAES.aesEncrypt(plainText, key + Often.null2Void(currentDate, "00000000000000"));
    }

    function splitAutoLoginKey(autoLoginKey) {
        var isElectron = ElectronApi.Comm.isElectron();
        if (autoLoginKey && autoLoginKey.indexOf("|") > -1) {
            var autoLoginKeyArray = autoLoginKey.split("|");
            var isExistsKey = (autoLoginKeyArray.length === 2 &&
                "" !== Often.null2Void(autoLoginKeyArray[0]) &&
                "" !== Often.null2Void(autoLoginKeyArray[1]))
            return isExistsKey && {
                USER_ID: autoLoginKeyArray[0],
                RAND_KEY: autoLoginKeyArray[1],
                OBJ_CNTS_NM: (isElectron ? "desktop" : "")
            }
        }
        return {}
    }

    function sendPwdChangeEmail() {

        const $pwdAlertText = $("#findPassword").find(".js-password-alert");
        let findEmailVal = $.trim(($findEmailInput|| $('#findEmailInput')).val());

        if ("" === findEmailVal) {
            Often.toast("error", i18next.t(main.alert.enterWord, {val: $t(dictionary.id), koreanPrefixEL: true}))
            return;
        }

        UserTracker = UserTracker || requireModule('userTracker', {on: ['signin', 'miniSignIn', 'corpsignin']})();
        UserTracker?.SignInTracker()?.track("pw-find-email-click")
        Ajax.executeApi(RestApi.GET.COLABO2_PWD_R001, {USER_ID: findEmailVal, RENEWAL_YN: "Y"}, function (dat) {
            if (Often.null2Void(dat.ERR_CD, "") !== "0000") {
                let errText = dat.ERR_CD === "2001" ? i18next.t(main.alert.invalidLoginID) : dat.ERR_CD;
                $pwdAlertText.html(Often.null2Void(dat.ERR_MSG, errText));
                ($findEmailInput || $('#findEmailInput')).focus().addClass('input-error');
                return;
            }
            $pwdAlertText.empty();
            ($findEmailInput || $('#findEmailInput')).removeClass('input-error');
            Often.toast("success", i18next.t(main.alert.checkPasswordEmail));
            ElectronApi.Comm.isElectron() && toggleLayer(false);
        });
    }

    function successTwoFactor() {
        var userId = $.trim($("#userId").val());
        var password = $.trim($("#password").val());
        var isElectron = ElectronApi.Comm.isElectron();
        goLogin({
            USER_ID: userId,
            PWD: password,
            ID_GB: SignCode.TYPE.NORMAL,
            ENCRYPT_YN: SignCode.ENCRYPT.SERVER_TIME_CHECK,
            OBJ_CNTS_NM: (isElectron ? "desktop" : "")
        })
    }

    function pwdInitPopDefaultSet(data) { // 비밀번호 변경 팝업 기본 설정
        $('#pwdInitPopSection').show();
        pwdInitPopDataInit(data['USER_ID']);
        pwdInitPopEventSet();
    }

    function pwdInitPopDataInit(userId) {    // 사용자 ID 셋팅
        $('#pwdInitPopSection #currentPwd').focus();
        $('#pwdInitPopSection').find('#pwdInitPopId').text(userId);
    }

    function pwdInitPopEventSet() {  // 비밀번호 변경 팝업 이벤트 설정
        var pwd1Input = ServerChecker.isEnter ? $('#pwdInitPopSection #pwdChange1') : "";
        var pwd2Input = ServerChecker.isEnter ? $('#pwdInitPopSection #pwdChange2') : "";
        var currentPwd = ServerChecker.isEnter ? $('#pwdInitPopSection #currentPwd') : "";
        var pwdChangeBtn = ServerChecker.isEnter ? $('#pwdInitPopSection #pwdChangeBtn') : "";
        var pwdInitPopCloseBtn = ServerChecker.isEnter ? $('#pwdInitPopSection #pwdInitPopCloseBtn') : "";
        // X 버튼 클릭 시
        pwdInitPopCloseBtn.off('click').on('click', function (e) {
            $('#pwdInitPopSection #pwdChange1').val('');
            $('#pwdInitPopSection #pwdChange2').val('');
            $('#pwdInitPopSection').hide();
            var pageUrl = _IsMini ? '/entMiniSignIn.act' : '/entsignin.act';
            location.href = pageUrl;
        });

        currentPwd.off('keyup').on('keyup', function (e) {
            if (e.keyCode == 27) { // esc

            } else if (e.keyCode == 13) { // enter
                if (!pwdChangeBtn.hasClass('active')) { // 비밀번호 변경 버튼이 활성화 안되어있으면
                    return;
                }
                fn_changePwd();
            } else {    // enter를 제외한 키보드 누를 때
                fn_checkPwdValidation();
            }
        });

        // 비밀번호 첫번째 input keyup & keydown 이벤트
        pwd1Input.off('keyup').on('keyup', function (e) {
            if (e.keyCode == 27) { // esc

            } else if (e.keyCode === 13) { // enter
                if (!pwdChangeBtn.hasClass('active')) { // 비밀번호 변경 버튼이 활성화 안되어있으면
                    return;
                }
                fn_changePwd();
            } else {    // enter를 제외한 키보드 누를 때
                fn_checkPwdValidation();
            }
        });

        // 비밀번호 두번째 input keyup & keydown 이벤트
        pwd2Input.off('keyup').on('keyup', function (e) {
            if (e.keyCode == 27) { // esc

            } else if (e.keyCode === 13) { // enter
                if (!pwdChangeBtn.hasClass('active')) {   // 비밀번호 변경 버튼이 활성화 안되어있으면
                    return;
                }
                fn_changePwd();
            } else {    // enter를 제외한 키보드 누를 때
                fn_checkPwdValidation();
            }
        });

        // 비밀번호 변경 click 이벤트
        pwdChangeBtn.off('click').on('click', function (e) {
            fn_changePwd();
        });
    }

    function loginOnGware(dat, passJson) {
        var pageUrl = "miniMain.act";
        var gwareUrl = Often.null2Void(dat.GWARE_URL, "");
        var rndKey = Often.null2Void(dat.RNDKEY, "");
        Often.setCookie("flowGwareUrl", gwareUrl, 30 * 12); // 30일 * 12월 = 1년.
        Often.setCookie("flowRndkey", rndKey, 30 * 12); // 30일 * 12월 = 1년.

        if (Often.getLocOrigin().indexOf("talk") > -1) {
            if (Often.null2Void(dat.FLOW_URL, "").indexOf(location.host) > -1) {
                pageUrl = "miniMain.act";
            } else {
                Often.setCookie("miniAddr", Often.null2Void(dat.FLOW_URL, "").replace("/MGateway", "")
                    + "/miniSignIn.act", 30 * 12 * 10);
                pageUrl = Often.null2Void(dat.FLOW_URL, "").replace("/MGateway", "") + "/miniSignIn.act";
            }
        }

        Often.submitForm("gtalk_form", pageUrl, "_self", {
            GWARE_URL: gwareUrl,
            RNDKEY: rndKey,
            USER_ID: passJson["ID"],
            PWD: passJson["PWD"],
        })
    }

    function fn_checkPwdValidation() {  // 비밀번호 validation 체크
        var pwd1 = ServerChecker.isEnter ? $('#pwdInitPopSection #pwdChange1').val() : "";
        var pwd2 = ServerChecker.isEnter ? $('#pwdInitPopSection #pwdChange2').val() : "";
        var currentPwd = ServerChecker.isEnter ? $('#pwdInitPopSection #currentPwd').val() : "";
        var pwdCheckMsg = ServerChecker.isEnter ? $('#pwdInitPopSection #pwdChkMsg') : "";
        var pwdChangeBtn = ServerChecker.isEnter ? $('#pwdInitPopSection #pwdChangeBtn') : "";
        // 둘다 값이 없는 경우
        if (Often.null2Void(pwd1, "") == "" || Often.null2Void(pwd2, "") == "" || Often.null2Void(currentPwd, "") == "") {
            pwdCheckMsg.hide();
            pwdChangeBtn.removeClass("active");
            return;
        }

        // pwd1 정규식 체크
        if (cmf_validate(Often.null2Void(pwd1))) {
            pwdCheckMsg.text(i18next.t(main.alert.invalidPasswordType) + "");
            pwdCheckMsg.css('color', "red");
            pwdCheckMsg.show();
            pwdChangeBtn.removeClass("active");
            // $('#pwdInitPopSection #pwdChange1').focus();
            return;
        } else {
            //done
        }

        if (pwd2 === "") {
            pwdCheckMsg.hide();
            return;
        }

        if (currentPwd == "") {
            pwdCheckMsg.text(i18next.t(common.passwordAlert));
            pwdCheckMsg.css('color', "red");
            pwdCheckMsg.show();
            pwdChangeBtn.removeClass("active");
            $('#pwdInitPopSection #currentPwd').focus();
            return;
        }
        if (pwd1 != pwd2) {
            pwdCheckMsg.text(Often.null2Void(i18next.t(main.alert.passwordNotMatch)));
            pwdCheckMsg.css('color', "red");
            pwdCheckMsg.show();
            pwdChangeBtn.removeClass("active");
            // $('#pwdInitPopSection #pwdChange1').focus();
            return;
        } else {
            pwdCheckMsg.hide();
            pwdChangeBtn.addClass("active");
        }
    }

    function fn_changePwd() { // 비밀번호 변경 버튼 클릭

        var userId = ServerChecker.isEnter ? $('#pwdInitPopSection #pwdInitPopId').text() : "";
        var pwd1 = ServerChecker.isEnter ? $('#pwdInitPopSection #pwdChange1').val() : "";
        var pwd2 = ServerChecker.isEnter ? $('#pwdInitPopSection #pwdChange2').val() : "";
        var currentPwd = ServerChecker.isEnter ? $('#pwdInitPopSection #currentPwd').val() : "";
        var pwdCheckMsg = ServerChecker.isEnter ? $('#pwdInitPopSection #pwdChkMsg') : "";
        var pwdChangeBtn = ServerChecker.isEnter ? $('#pwdInitPopSection #pwdChangeBtn') : "";

        // pwd1 과 pwd2 일치 확인
        if (currentPwd == "") {
            pwdCheckMsg.text("현재 비밀번호를 입력하세요.");
            pwdCheckMsg.css('color', "red");
            pwdCheckMsg.show();
            pwdChangeBtn.removeClass("active");
            $('#pwdInitPopSection #currentPwd').focus();
            return;
        }
        if (pwd1 != pwd2) {
            pwdCheckMsg.text(Often.null2Void(i18next.t(main.alert.passwordNotMatch)));
            pwdCheckMsg.css('color', "red");
            pwdCheckMsg.show();
            pwdChangeBtn.removeClass("active");
            $('#pwdInitPopSection #pwdChange1').focus();
            return;
        } else {
            const isValidPassword = new RegExp(Validation.getPasswordRex()).test(pwd1);
            if(!isValidPassword) {
                pwdCheckMsg.text(i18next.t(common.passwordWarning));
                pwdCheckMsg.css('color', "red");
                pwdCheckMsg.show();
                pwdChangeBtn.removeClass("active");
                $('#pwdInitPopSection #pwdChange1').focus();
                return;
            }
            const passwordData = {
                "USER_ID": userId,
                "RGSN_DTTM": Time.currentTime('type16'),
                "PWD": pwd1,
                "USER_GB": "INIT",
                "CURR_PWD": currentPwd,
                "packetOption": Ajax.OPTION.PREVENT_EXECUTE
            }
            Ajax.executeApi(RestApi.PUT.COLABO2_PWD_U002, passwordData, changePasswordCallback);
        }
    }

    function changePasswordCallback() {
        $('#pwdInitPopSection').hide();

        Often.toast('success', i18next.t(main.alert.passwordChangeResignIn));

        if (window.ServerChecker?.isEnter) {
            setTimeout(function () {
                var pageUrl = _IsMini ? '/entMiniSignIn.act' : '/entsignin.act';
                location.href = pageUrl;
            }, 1500);
        }
    }

    // 사용자 비밀번호 정규식 체크 / (8자 이상, 숫자/문자/특수기호 3가지)
    function cmf_validate(ObjUserPassword) {
        if (0 === VarCharCount(ObjUserPassword)) {
            return true;
        } else {
            //done.
        }
        var pattern = /^.*(?=^.{8,20}$)(?=.*\d)(?=.*[a-zA-Z]).*$/g;
        if (!pattern.test(ObjUserPassword)) return true;
        else return false;
    }

    //특수문자 한개 포함해야함.
    function VarCharCount(aInputBox) {  // aInputBox에 있는 특수문자의 갯수 return
        var comp = "\`~!@#$%^&*-_+=\\,./?:;\"{[}]";
        var aInputBoxValue = aInputBox;
        var len = aInputBoxValue.length;
        var count = 0;
        if (len > 0) {
            for (var i = 0; i < len; i++) {
                if (comp.indexOf(aInputBoxValue.substring(i, i + 1)) > -1) {
                    count++;
                }
            }
        }
        return count;
    }

    function lockedAccountPop(dat) {
        const lockedAccountPopSection = $("#lockedAccountPopSection");
        lockedAccountPopSection.show();

        const authenticateSmsBtn = $("#lockedAccountPopSection #authenticateSmsBtn");
        const authenticateSmsCloseBtn = $("#lockedAccountPopSection #authenticateSmsCloseBtn");
        const deviceJson = Often.getDeviceJson(_CLIENT_IP);

        authenticateSmsCloseBtn.focus();

        authenticateSmsBtn.off("click").on("click", () => { // SMS 인증하기
            lockedAccountPopSection.hide();

            if (Often.null2Void(dat.AUTH_TYPE, "") !== "" && Often.null2Void(dat.AUTH_YN, "N") === "N") {
                let authId = EmailAuth.getAuthId(dat);
                if (authId === "") return;

                Ajax.executeApi(RestApi.GET.FLOW_AUTH_NO_CHECK_R002, $.extend({}, deviceJson, {
                    "USER_ID": dat.USER_ID,
                    "EML": authId,
                    "AUTH_TYPE": dat.AUTH_TYPE,
                }), function (dat) {
                    EmailAuth.setCounter(dat);
                });
                EmailAuth.openAuthView(dat.USER_ID, authId, dat.AUTH_TYPE, false, () => assignPasswordPop(authId));

                return;
            }
        });

        authenticateSmsCloseBtn.off("click").on("click", () => { // 확인
            lockedAccountPopSection.hide();
        });
    }

    function assignPasswordPop(authId) {
        let authIdText = Profile.convertClphNo(authId).replace(/ /gi, "-");
        if (authIdText.length > 2) authIdText = authIdText.substr(0, authIdText.length - 2) + "**";

        $("#protectedNumber").text(authIdText);

        $("#assignPasswordPopSection").show();

        $("#assignPasswordPopSection #assignPasswordCloseBtn").off("click").on("click", () => {
            $("#assignPasswordPopSection").hide();
            var pageUrl = _IsMini ? '/entMiniSignIn.act' : '/entsignin.act';
            location.href = pageUrl;
        });
    }

    // 미래에셋 통합 로그인 이벤트 by. 홍섭
    async function clickIntegratedAuthLogin() {
        var isElectron = ElectronApi.Comm.isElectron();
        var agent = navigator.userAgent.toLowerCase();
        var isIE = (navigator.appName == 'Netscape' && agent.indexOf('trident') != -1) || agent.indexOf("msie") != -1;

        if (isElectron) {
            var ocxValue = await ElectronApi.Login.executeOCXInstallCheck();

            switch (ocxValue) {
                case "OCX_TIMEOUT":
                    Often.toast("error", "통합 로그인 인증 시간이 만료되었습니다.");
                    break;
                case "NO_OCX":
                    break;
                default:
                    AdLogin.mra.mraReplaceUserInfm(ocxValue);
                    break;
            }
        } else if (isIE) {
            // Todo. ie 경우 ActiveX 처리
            AdLogin.mra.mraActiveXLoginStart();
        }
        return;
    }

    function onEventIntegratedAuthLogin() {
        const isElectron = ElectronApi.Comm.isElectronAvailable();
        const agent = navigator.userAgent.toLowerCase();
        const isIE = (navigator.appName == 'Netscape' && agent.indexOf('trident') != -1) || agent.indexOf("msie") != -1;
        const $integratedAuthLogin = $("#integratedAuthLogin");

        if (isElectron || isIE) {
            $integratedAuthLogin?.show().off("click").on("click", clickIntegratedAuthLogin);
        } else {
            $integratedAuthLogin?.remove();
        }
    }

    function isThirdParty () {
        const url = new URL(location.href);
        const isGmailOAuth = Often.null2Void(url.searchParams.get('gmail_workspace_oauth')).includes('true');
        const isOutlookOAuth = Often.null2Void(url.searchParams.get('outlook_addin')).includes('true');
        const isTeams = Often.null2Void(url.searchParams.get('teams_app')).includes('true');
        const isThirdPartySignin = url.pathname.includes('/email_extension_auth.act') || url.pathname.includes('/emailextensionsignin.act');
        return {
            isGmailOAuth :  isGmailOAuth,
            isOutlookOAuth : isOutlookOAuth,
            isTeams : isTeams,
            anyMatch : isGmailOAuth || isOutlookOAuth || isTeams || isThirdPartySignin
        }
    }

    function getCompanyCode(e) {
        const $target = $(e.target);
        if($target.findUp('.dropdown-menu').length > 0) return;

        Ajax.executeApi("FLOW_COMPANY_INFO_R001", {
            "SUB_DOM_NM": SUB_DOM
            // "SUB_DOM_NM": "SECO"
        }).then(dat => {
            if (cnts_Null2Void(dat.COMPANY_LIST, "") != "") {
                const list = JSON.parse(dat.COMPANY_LIST);

                const listObj = $target.findUp('.company-select-list').find('.dropdown-menu');
                // listObj.mCustomScrollbar("destroy");
                listObj.empty();
                list.forEach(function(v) {
                    let itemObj = document.createElement("li");
                    itemObj.innerText = v.cpn_name;
                    itemObj.addEventListener('click', function(){
                        Often.setCookie('SECO_COMPANY_CODE', v.cpn_code, 30 * 12); // 30일 *
                                                                                // 12개월 = 1년
                        Often.setCookie('SECO_COMPANY_NAME', v.cpn_name, 30 * 12); // 30일 *
                                                                                // 12개월 = 1년
                        $('.company-select-list #companyName').val(v.cpn_name);
                        $('.company-select-list #companyCode').val(v.cpn_code);
                        listObj.removeClass('on');
                    })
                    listObj.append(itemObj);
                });
                listObj.addClass('on');
                // $("#companyCodeLayer").mCustomScrollbar();
            }
        })
    }

    function getOTPType(e) {
        const $target = $(e.target);
        if ($target.closest('.dropdown-menu').length <= 0) return;

        $('.otp-select-list #otpName').val($target.text());
        $('.otp-select-list #otpType').val($target.attr('value'));
    }
})()
